import React from 'react';
import { Star, Quote } from 'lucide-react';
import { siteData } from '../data/siteData';
import { Card, CardContent } from './ui/card';

const Reputation = () => {
  return (
    <section id="opiniones" className="py-16 sm:py-24 bg-[var(--color-cream)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-16">
          <span className="inline-block px-4 py-1.5 bg-[var(--color-yellow)]/20 text-[var(--color-orange)] text-sm font-medium rounded-full mb-4">
            Lo que dicen de nosotros
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[var(--text-primary)] mb-4">
            Opiniones reales
          </h2>
          
          {/* Rating Summary */}
          <div className="flex items-center justify-center gap-4 mt-6">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className={`w-6 h-6 ${
                    i < Math.floor(siteData.reputation.rating)
                      ? 'fill-[var(--color-yellow)] text-[var(--color-yellow)]'
                      : 'fill-gray-200 text-gray-200'
                  }`}
                />
              ))}
            </div>
            <span className="text-3xl font-bold text-[var(--text-primary)]">
              {siteData.reputation.rating}
            </span>
            <span className="text-[var(--text-secondary)]">
              ({siteData.reputation.totalReviews} opiniones)
            </span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {siteData.reputation.reviews.map((review, index) => {
            const colors = [
              'border-l-[var(--color-magenta)]',
              'border-l-[var(--color-cyan)]',
              'border-l-[var(--color-purple)]',
            ];

            return (
              <Card
                key={review.id}
                className={`bg-white border-l-4 ${colors[index % colors.length]} hover:shadow-lg transition-all duration-300 hover:-translate-y-1`}
              >
                <CardContent className="p-6">
                  <Quote className="w-8 h-8 text-[var(--color-magenta)]/20 mb-4" />
                  <p className="text-[var(--text-secondary)] leading-relaxed mb-4">
                    "{review.text}"
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-[var(--text-primary)]">
                      {review.author}
                    </span>
                    <div className="flex items-center gap-0.5">
                      {[...Array(review.rating)].map((_, i) => (
                        <Star
                          key={i}
                          className="w-4 h-4 fill-[var(--color-yellow)] text-[var(--color-yellow)]"
                        />
                      ))}
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Google Badge */}
        <div className="text-center mt-10">
          <p className="text-sm text-[var(--text-muted)]">
            Opiniones verificadas en Google Maps
          </p>
        </div>
      </div>
    </section>
  );
};

export default Reputation;
